import { applySnapshot, types } from 'mobx-state-tree';

// const data = types.model('data', {
//   isPermissionCheck: types.maybeNull(types.boolean),
// });

const UserPermissionCheck = types
  .model('UserPermissionCheck', {
    isPermissionCheck: types.maybeNull(types.boolean)
  })
  .actions((self) => ({
    set(response) {
      applySnapshot(self, response);
    }
  }));

export default UserPermissionCheck;
